import { render } from "./start-date.vue?vue&type=template&id=1511ed1c&lang=pug"
import script from "./start-date.vue?vue&type=script&setup=true&lang=js"
export * from "./start-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__